import { render, staticRenderFns } from "./AdvancedTab.vue?vue&type=template&id=6a183520&scoped=true"
import script from "./AdvancedTab.vue?vue&type=script&lang=js"
export * from "./AdvancedTab.vue?vue&type=script&lang=js"
import style0 from "./AdvancedTab.vue?vue&type=style&index=0&id=6a183520&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a183520",
  null
  
)

export default component.exports